<template>
<div>
  <v-text-field data-trustee="name"
      v-model="trustee.name" 
      label="Trustee Name" 
      required>
  </v-text-field>
  <v-text-field data-trustee="address"
      v-model="trustee.address" 
      label="Trustee Address" 
      required>
  </v-text-field>
  <v-text-field data-trustee="city"
      v-model="trustee.city" 
      label="Trustee City" 
      required>
  </v-text-field>
  <v-text-field data-trustee="state"
      v-model="trustee.state" 
      label="Trustee State" 
      required>
  </v-text-field>
  <v-text-field data-trustee="postalcode"
      v-model="trustee.postalCode" 
      label="Trustee Postalcode" 
      required>
  </v-text-field>
  <v-text-field data-trustee="origin"
      v-model="trustee.origin" 
      label="Trustee State of Origin" 
      required>
  </v-text-field>
  <v-text-field data-trustee="email"
      v-model="trustee.email" 
      label="Trustee Email" 
      required>
  </v-text-field>
</div>
</template>

<script>
export default {
  data: () => ({}),
  props: ["trustee"],
  computed: {},
  methods: {}
};
</script>

<style>
</style>
